export const ASYNC_FETCH = 'ILD_FeatureCompare/ASYNC_FETCH';
export const ASYNC_FETCH_SUCCESS_ILDFEATURECOMP = 'ILD_FeatureCompare/ASYNC_FETCH_SUCCESS_ILDFEATURECOMP';
export const ASYNC_FETCH_FAILURE = 'ILD_FeatureCompare/ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_INVALIDATE = 'ILD_FeatureCompare/ASYNC_FETCH_INVALIDATE';
export const SET_FEATURECOMP_DATA = 'ILD_FeatureCompare/SET_FEATURECOMP_DATA';
/**
 * action types
 * @type {string}
 */
